var map = {
	"./eight.png": 7587,
	"./eleven.png": 8408,
	"./five.png": 9917,
	"./four.png": 6189,
	"./nine.png": 6202,
	"./one.png": 9983,
	"./seven.png": 1715,
	"./six.png": 5337,
	"./ten.png": 2254,
	"./three.png": 9968,
	"./twelev.png": 3555,
	"./two.png": 7153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3866;